import React, {Component, Fragment} from 'react';
import DealerCta from './DealerCta';
import Disclaimer from './Disclaimer';
import '../css/ResultsView.css';
import ResultsRow from './ResultsRow';
import DaikinRebate from './DaikinRebate';
import TotalsRow from './TotalsRow';

class ResultsView extends Component {
	constructor(props) {
		super(props);
	
		this.reset = this.reset.bind(this);
	}

	reset = (event) => {
		event.preventDefault();
		this.props.viewResult(false);
	}

	render() {
		let width = this.props.dimensions.width;
		const classes = (width >= 684 )
		? "app__results-wrap app__responsive-row app__emco-wide"
		: "app__results-wrap app__responsive-row";

		let displayDealerCta = '';
		if ( this.props.config.displaycta === true) {
			displayDealerCta = (<DealerCta dimensions={this.props.dimensions} config={this.props.config} content={this.props.content.dealercta}/>);
		}
	
		const provinceRebate = this.props.content[this.props.result.province];
		const rebate = (provinceRebate) ? provinceRebate[this.props.result.heatpumptype] : '';
		const viewAlt = (this.props.result.heatpumptype === 'furnace') ? true : false;

		let displayDaikinRebate = '';
		if (this.props.result.heatpumptype !== 'furnace') {
			displayDaikinRebate = (<DaikinRebate
				classes={classes}
				content={this.props.content}
				result={this.props.result.heatpumptype}
			/>);
		}

		return (
			<Fragment>
				<div id="app__results" className="app__results" ref="scrolltotop">
					<ResultsRow
						classes={classes}
						content={this.props.content}
						result={rebate}
						lowincome={this.props.result.lowincome}
					/>

					{displayDaikinRebate}

					<TotalsRow
						classes={classes}
						content={this.props.content}
						reset={this.reset}
						result={rebate}
						startOver={viewAlt}
						lowincome={this.props.result.lowincome}
					/>

					{displayDealerCta}

					<Disclaimer config={this.props.config} content={this.props.content.disclaimer} lang={this.props.config.lang}/>
				</div>
			</Fragment>
		)
	}
}

export default ResultsView;



// WEBPACK FOOTER //
// ./src/components/ResultsView.js